import { useMemo } from 'react';

import salesTypes from 'maps/sales-types';
import getSalesTypeOptions from 'helpers/getSalesTypeOptions';

import { EntityTypes } from 'context/entityContext';

const useAllSalesOptions = (
  isExternalUser: boolean,
  tableName?: string,
  entityType?: string,
  hasMedia?: boolean
): any => {
  return useMemo(() => {
    if (entityType && tableName !== 'customLists') {
      return getSalesTypeOptions(
        isExternalUser,
        entityType as EntityTypes,
        undefined,
        undefined,
        hasMedia
      );
    } else {
      const result = [
        salesTypes['streaming'],
        salesTypes['downloads'],
        ...(hasMedia ? [] : [salesTypes['physical']]),
      ];
      if (!isExternalUser) {
        result.unshift(salesTypes['equivalents']);
      }
      return result;
    }
  }, [isExternalUser, tableName, entityType, hasMedia]);
};

export default useAllSalesOptions;
